import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import $ from 'jquery';

import Basic from '../Components/Basic/Basic';
import Toast from '../Components/Toast/Toast';
import Common from '../services/common.js';

const UploadInvestorDoc = () => {
  const [errors, setErrors] = useState([]);
  const [docFile, setDocFile] = useState(null);
  const [token, setToken] = useState('');
  const [investor, setInvestor] = useState('');
  const [linkCode, setLinkCode] = useState('');
  const [docName, setDocName] = useState('Request for deposit');
  const [docFileError, setDocFileError] = useState('');
  const [form, setForm] = useState({
    doc_file_name: ''
  });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [urlParas, setUrlParas] = useState({});
  
  const STORAGE_KEY = "caprock-local";
  const session = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  const location = useLocation();
  const navigate = useNavigate();
  const toastRef = useRef();
  const errorBlockRef = useRef();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get('token');
    const investorParam = queryParams.get('investor');
    const linkCodeParam = queryParams.get('ltoken');
    
    setUrlParas({
      token: tokenParam,
      investor: investorParam,
      ltoken: linkCodeParam
    });
    setToken(tokenParam);
    setInvestor(investorParam);
    setLinkCode(linkCodeParam);
    
    tokenAlert();
    
    if (linkCodeParam && linkCodeParam !== '') {
      getLinkDetails(linkCodeParam);
    }
    
    document.title = docName + ' || Caprock Merchant Platform';
  }, []);

  const fetchFile = (event) => {
    const file = event.target.files[0];
    if (event.target.name === 'doc_file') {
      setDocFile(file);
      setForm(prev => ({
        ...prev,
        doc_file_name: file.name
      }));
    }
  };

  const tokenAlert = () => {
    if (typeof token === 'undefined' || token === '') {
      alert('This URL is invalid please contact caprock support team');
      window.location.href = 'https://caprock.com.au';
    }
  };

  const getLinkDetails = (linkCode) => {
    Common.get_link_details(linkCode)
      .then(response => {
        console.log(response.data);
        
        if (typeof response.data !== 'undefined' && response.data.success !== 200) {
          alert('Link expired!');
          window.location.href = "https://caprock.com.au";
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const submitForm = (e) => {
    let formData = new FormData();
    
    if (typeof docFile !== 'undefined') {
      formData.append('doc_file', docFile);
      $('#subBtn').attr('disabled', 'disabled');
      $('#subBtn').text('Processing ... ');
      formData.append('token', token);
      formData.append('doc_name', 'Request for deposit');
      formData.append('investor_id', investor);
      formData.append('link_code', linkCode);

      const url = Common.base_url() + 'upload-investor-document';
      
      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success === 200) {
          toastRef.current.miralToast(
            'Success',
            data.message,
            '',
            false
          );
          
          setTimeout(() => {
            navigate('/sign-in');
          }, 2500);

          $('#subBtn').removeAttr('disabled');
          $('#subBtn').text('Upload Now');
        } else {
          toastRef.current.miralToast(
            'Warning',
            data.message,
            '',
            false
          );
          
          $('#subBtn').removeAttr('disabled');
          $('#subBtn').text('Upload Now');
        }
      })
      .catch(error => {
        $('#subBtn').removeAttr('disabled');
        $('#subBtn').text('Upload Now');
      });
    } else {
      setDocFileError('Please select valid document for upload.');
      toastRef.current.miralToast(
        'Warning',
        'Please select valid document for upload.',
        '',
        false
      );
      return false;
    }
  };

  const removeErr = (event) => {
    $('.' + event.currentTarget.id + 'err').remove();
  };

  const openModal = (id) => {
    $('#' + id).addClass('d-block');
    $('#' + id).addClass('show');
    $('#' + id).css('overflow-y', 'scroll');
  };

  const closeModal = (id) => {
    $('#' + id).removeClass('d-block');
    $('#' + id).addClass('d-none');
    $('#' + id).removeClass('show');
  };

  return (
    <>
      <Basic />
      <section className="closefriend-hero background-white">
        <div className="container mt-5 d-flex justify-content-center">
          <form method="POST" action="/" className="my-1">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2">
                <div className="login-card">
                  <div className="login-body">
                    <div className="row">
                      <div className="col-md-12 col-12">
                        <p style={{ fontSize: '2rem', fontWeight: 700, letterSpacing: '0.1rem', lineHeight: 'normal' }}>
                          Upload your {docName} document !
                        </p>
                      </div>
                    </div>
                    <div className="form-group mt-1 mb-0">
                      <input
                        onChange={(e) => {
                          fetchFile(e);
                          setDocFileError('');
                        }}
                        id="doc_file"
                        type="file"
                        className="form-control selected-field"
                        name="doc_file"
                        required
                      />
                      <small className="errorMsg danger ml-2">{docFileError}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2">
                <div className="row justify-content-center mx-md-0 mx-1 mb-1 mt-0">
                  <div className="col-md-12 col-12 px-1">
                    <div className="text-muted text-right">
                      <a className="success" href="/sign-in" style={{ color: '#333', fontSize: '0.9rem' }}>
                        Sign In ?
                      </a>
                    </div>
                    <button
                      id="subBtn"
                      type="button"
                      onClick={submitForm}
                      className="btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                    >
                      Upload Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Please fix this</h5>
              <button
                type="button"
                onClick={() => closeModal('exampleModal')}
                className="btn btn-secondary"
                data-mdb-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <div ref={errorBlockRef} id="errorBlock">
                {errors.length > 0 && errors.map((error, key) => (
                  <div key={key} className="alert alert-danger">
                    {error}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Toast ref={toastRef} />
    </>
  );
};

export default UploadInvestorDoc;

// CSS Styles
const styles = `
  .form-group {
    margin-bottom: 2rem;
  }
  
  .form-control {
    background: transparent !important;
    border-bottom: 1px solid grey !important;
  }
`;

// Inject styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
